import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';
import { Segment } from 'components';
import { colors } from 'utils/colors';
import { translation as translationTools } from '../../Translation/tools';
import Similarity from './Similarity';
import Category from './Category';

// eslint-disable-next-line react/prefer-stateless-function
class ETFAgent extends Component {
  render() {
    const { etfData, french } = this.props;
    const { isByCategory } = etfData;
    const language = french ? 'fr' : 'en';
    const t = translationTools[language].ETF_AGENT;

    return (
      <Segment
        margin="1rem"
        padding="0rem"
        textAlign="center"
        style={{
          position: 'relative',
          minHeight: '710px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ flex: 1, position: 'relative' }}>
          {isByCategory ? <Category /> : <Similarity />}
        </div>

        <InfoWrapper>
          <Popup
            trigger={<InfoTrigger tabIndex={0}>{t.INFO_TRIGGER}</InfoTrigger>}
            content={t.INFO_TEXT}
            on={['hover', 'focus']}
            position="top center"
            style={{
              width: '720px',
              maxWidth: '85vw',
              padding: '1.25rem 1.5rem',
              fontSize: '16px',
              lineHeight: 1.6,
              textAlign: 'left',
              color: '#333',
            }}
          />
        </InfoWrapper>
      </Segment>
    );
  }
}

ETFAgent.propTypes = {
  etfData: PropTypes.object,
  french: PropTypes.bool,
};

ETFAgent.defaultProps = {
  etfData: {},
  french: false,
};

export default connect((state) => ({
  etfData: state.ETFAgent,
  french: state.Storage.language === 'fr',
}))(ETFAgent);

const InfoWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 2rem 0 1rem;
  margin-top: 2rem;
  border-top: 1px solid #e4e7ec;
  background-color: white;
`;

const InfoTrigger = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.blue};
  cursor: pointer;
  outline: none;
`;
